import { MathUtils } from 'three';
import { TilesRenderer } from '3d-tiles-renderer';
import {
  GoogleCloudAuthPlugin,
  ReorientationPlugin,
  GLTFExtensionsPlugin,
} from '3d-tiles-renderer/plugins';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
import { KTX2Loader } from 'three/addons/loaders/KTX2Loader.js';

const DRACO_DECODER_PATH = 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/';
const KTX2_TRANSCODER_PATH = 'https://unpkg.com/three@0.184.0/examples/jsm/libs/basis/';

// Real-time Google Photorealistic 3D Tiles: tiles stream directly from
// tile.googleapis.com worldwide (no local pre-download). GoogleCloudAuthPlugin
// fetches the global root tileset and manages the session token. Billing is per
// root-tileset request (≈1 per play session, ~3h, worldwide); child tile/glb
// requests are unlimited & free.
export function createTilesRenderer({
  apiKey, lat, lng, height = 0, renderer,
  errorTarget = 6, lruMaxSize = 2500,
}) {
  const draco = new DRACOLoader().setDecoderPath(DRACO_DECODER_PATH);
  const ktx2 = new KTX2Loader()
    .setTranscoderPath(KTX2_TRANSCODER_PATH)
    .detectSupport(renderer);

  const tiles = new TilesRenderer();

  tiles.registerPlugin(
    new GoogleCloudAuthPlugin({
      apiToken: apiKey,
      autoRefreshToken: true,
    })
  );
  tiles.registerPlugin(
    new GLTFExtensionsPlugin({
      dracoLoader: draco,
      ktxLoader: ktx2,
    })
  );
  tiles.registerPlugin(
    new ReorientationPlugin({
      lat: MathUtils.degToRad(lat),
      lon: MathUtils.degToRad(lng),
      height,
      recenter: true,
    })
  );

  // Larger LRU keeps tiles cached during long flights so they don't reload when
  // the camera returns to a previously-visited area. PC (max detail) uses a
  // bigger cache to avoid thrashing at very low errorTarget.
  tiles.lruCache.minSize = Math.round(lruMaxSize * 0.6);
  tiles.lruCache.maxSize = lruMaxSize;

  // Screen-space error target (px). Lower = sharper (pulls finer Google LOD,
  // down to ~Google Earth quality) but heavier streaming / GPU / memory.
  // PC mode passes ~1 (maximum detail); mobile passes a higher value for perf.
  tiles.errorTarget = errorTarget;

  return tiles;
}
